import AuthenticatedResource from 'resources/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class ClientDashboardResource extends AuthenticatedResource {
  static urlRoot = '/organization/:organization/client_dashboard';

  id                = undefined;
  fields            = [];

  pk() {
    return this.id && this.id.toString();
  }
}
